import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaProcedimentoAssociados.vue?vue&type=template&id=cbeac262&scoped=true"
import script from "./ModalSolicitacaoCirurgiaProcedimentoAssociados.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaProcedimentoAssociados.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaProcedimentoAssociados.vue?vue&type=style&index=0&id=cbeac262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbeac262",
  null
  
)

export default component.exports